import { defineMessages } from '@atlassian/jira-intl';
import type { MessageDescriptorV2 as MessageDescriptor } from '@atlassian/jira-intl/src/v2/types.tsx';

export const messages: Record<string, MessageDescriptor> = defineMessages({
	showMeButton: {
		id: 'polaris-components-quickstart.show-me-button.show-me-button.non-final',
		defaultMessage: 'Show me',
		description: 'The button to show the next spotlight in the tour',
	},
});
